// @flow
import { RolesActionTypes } from './constants';

type RolesAction = { type: string, payload: {} | string };

// common success
export const rolesApiResponseSuccess = (actionType: string, data: any): RolesAction => ({
    type: RolesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const rolesApiResponseError = (actionType: string, error: string): RolesAction => ({
    type: RolesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const listRoles = (): RolesAction => ({
    type: RolesActionTypes.LIST_ROLES,
    payload: {},
});
export const getRole = (id: string): RolesAction => ({
    type: RolesActionTypes.GET_ROLE,
    payload: { id },
});

export const getRoleTopbar = (id: any): RolesAction => ({
    type: RolesActionTypes.GET_ROLE_TOPBAR,
    payload: { id },
});

export const addRole = (role:any):RolesAction=>({
    type:RolesActionTypes.ADD_ROLE,
    payload:role
})
export const updateRole = (role:any):RolesAction=>({
    type:RolesActionTypes.UPDATE_ROLE,
    payload:role
})
export const deleteRole = (id:string):RolesAction=>({
    type:RolesActionTypes.DELETE_ROLE,
    payload:{id}
})

export const resetRoles = (): RolesAction => ({
    type: RolesActionTypes.RESET,
    payload: {},
});

